import { FooterMaximized } from "components/footerfull";
import Header from "components/headerfull";
import { Banner, SEOgenericContent } from "./subCategory";

const PDDtext1 = {
    "titles": {
        "h1": [
            {
                "text": "Règlement Général sur la Protection des Données",
                "isgrad": false
            }
        ]
    },
    "data": [
        {
            "h2": "Le but de cette politique de confidentialité",
            "contents": [
                {
                    "type": "paragraph",
                    "inner": "Le but de cette politique de confidentialité est d'informer les utilisateurs de notre site des données personnelles que nous recueillerons ainsi que les informations suivantes, le cas échéant :"
                },
                {
                    "type": "list",
                    "inner": [
                        {
                            "paragraph": "Les données personnelles que nous recueillerons"
                        },
                        {
                            "paragraph": "L’utilisation des données recueillies"
                        },
                        {
                            "paragraph": "Qui a accès aux données recueillies"
                        },
                        {
                            "paragraph": "Durée de conservation des données collectées"
                        },
                        {
                            "paragraph": "La politique de cookies du site"
                        },
                        {
                            "paragraph": "Comment nous protégeons vos données"
                        },
                        {
                            "paragraph": "Transferts internationaux"
                        },
                        {
                            "paragraph": "Vos droits concernant vos données"
                        },
                    ]
                },
                {
                    "type": "parargaph",
                    "inner" : "Cette politique de confidentialité fonctionne parallèlement aux conditions générales d’utilisation de notre site."
                }
            ]
        },
        {
            "h2": "Lois applicables",
            "contents": [
                {
                    "type": "paragraph",
                    "inner": "Conformément au Règlement général sur la protection des données (RGPD), cette politique de confidentialité est conforme aux règlements suivants."
                },
                {
                    "type": "paragraph",
                    "inner": "Les données à caractère personnel doivent être :\nTraitées de manière licite, loyale et transparente au regard de la personne concernée (licéité, loyauté, transparence) ;\nCollectées pour des finalités déterminées, explicites et légitimes, et ne pas être traitées ultérieurement d'une manière incompatible avec ces finalités ; le traitement ultérieur à des fins archivistiques dans l'intérêt public, à des fins de recherche scientifique ou historique ou à des fins statistiques n'est pas considéré, conformément à l'article 89, paragraphe 1, comme incompatible avec les finalités initiales (limitation des finalités) ;\nAdéquates, pertinentes et limitées à ce qui est nécessaire au regard des finalités pour lesquelles elles sont traitées (minimisation des données) ;\nExactes et, si nécessaire, tenues à jour ; toutes les mesures raisonnables doivent être prises pour que les données à caractère personnel qui sont inexactes, eu égard aux finalités pour lesquelles elles sont traitées, soient effacées ou rectifiées sans tarder (exactitude) ;\nconservées sous une forme permettant l'identification des personnes concernées pendant une durée n'excédant pas celle nécessaire au regard des finalités pour lesquelles elles sont traitées; les données à caractère personnel peuvent être conservées pour des durées plus longues dans la mesure où elles seront traitées exclusivement à des fins archivistiques dans l'intérêt public, à des fins de recherche scientifique ou historique ou à des fins statistiques conformément à l'article 89, paragraphe 1, pour autant que soient mises en œuvre les mesures techniques et organisationnelles appropriées requises par le règlement afin de garantir les droits et libertés de la personne concernée (limitation de la conservation) ;\nTraitées de façon à garantir une sécurité appropriée des données à caractère personnel, y compris la protection contre le traitement non autorisé ou illicite et contre la perte, la destruction ou les dégâts d'origine accidentelle, à l'aide de mesures techniques ou organisationnelles appropriées (intégrité et confidentialité).\nLe traitement n'est licite que si, et dans la mesure où, au moins une des conditions suivantes est remplie :\nLa personne concernée a consenti au traitement de ses données à caractère personnel pour une ou plusieurs finalités spécifiques ;\nLe traitement est nécessaire à l'exécution d'un contrat auquel la personne concernée est partie ou à l'exécution de mesures précontractuelles prises à la demande de celle-ci ;\nLe traitement est nécessaire au respect d'une obligation légale à laquelle le responsable du traitement est soumis ;\nLe traitement est nécessaire à la sauvegarde des intérêts vitaux de la personne concernée ou d'une autre personne physique ;\nLe traitement est nécessaire à l'exécution d'une mission d'intérêt public ou relevant de l'exercice de l'autorité publique dont est investi le responsable du traitement ;\nLe traitement est nécessaire aux fins des intérêts légitimes poursuivis par le responsable du traitement ou par un tiers, à moins que ne prévalent les intérêts ou les libertés et droits fondamentaux de la personne concernée qui exigent une protection des données à caractère personnel, notamment lorsque la personne concernée est un enfant."
                },
            ]
        },
        {
            "h2": "Consentement",
            "contents": [
                {
                    "type": "paragraph",
                    "inner": "Les utilisateurs conviennent qu’en utilisant notre site, ils consentent à :\nLes conditions énoncées dans la présente politique de confidentialité et\nLa collecte, l’utilisation et la conservation des données énumérées dans la présente politique."
                },
            ]
        },
        
        {
            "h2": "Données personnelles que nous collectons",
            "contents": [
                {
                    "type": "title",
                    "inner": "Données collectées automatiquement"
                },
                {
                    "type": "paragraph",
                    "inner": "Nous ne collectons aucune donnée de façon automatique sur notre site."
                },
                {
                    "type": "title",
                    "inner": "Données recueillies de façon non automatique / via un formulaire"
                },
                {
                    "type": "paragraph",
                    "inner": "Nous collectons les données suivantes lorsque vous effectuez certaines fonctions sur notre site :\nDans le cadre de votre utilisation de nos services et de votre navigation sur notre site internet, WOS traite plusieurs catégories de données dont vous trouverez le détail ci-dessous. Ces données proviennent :"
                },
                {
                    "type": "paragraph",
                    "inner": "Des informations que vous nous communiquez.\nDes informations résultant de votre utilisation de nos services.\nNous ne traitons pas de catégories particulières de données (données sensibles) telles que les données qui révèlent l'origine raciale ou ethnique, les opinions politiques, les convictions religieuses ou philosophiques ou l'appartenance syndicale, des données génétiques, des données biométriques, des données concernant la santé ou des données concernant la vie sexuelle ou l'orientation sexuelle des personnes."
                },
                {
                    "type": "list",
                    "inner": [
                        {
                            "h3": "Données relatives aux workers",
                            "paragraph": "Les workers désignent les personnes s’inscrivant sur WOS et qui proposent leurs services aux clients via la plateforme. Nous vous informons au moment de la collecte du caractère obligatoire ou non du renseignement de la donnée.",
                            "table": {
                                "th": [
                                    "Type de collecte",
                                    "Catégorie",
                                    "Détails"
                                ],
                                "tr": [
                                    [
                                        "Communiqué par le Worker",
                                        "Informations personnelles",
                                        "- Nom\n- Prénom\n- Lieu de naissance \n- Date de naissance\n- Numéro de téléphone\n- adresse email\n- Catégorie professionnelle\n- Photo de profil\n- Nationalité\n-Adresse du worker\n-Informations de paiement\n-Société de rattachement\n-Justificatif de rattachement à la société\n- audio de présentation \n-Motivations pour la mission/poste",
                                    ],
                                    [
                                        "",
                                        "Informations professionnelles",
                                        "- Expériences professionnelles\n- Compétences\n- Préférences(s) de mission\n-CV\n-Tarif mission/poste",
                                    ],
                                    [
                                        "",
                                        "Informations relatives aux échanges avec nos équipes WOS",
                                        "- Échanges entre le worker et le client (via le chat de la plateforme)\n- Dates et durées des appels téléphoniques et appels en visioconférence",
                                    ],
                                    [
                                        "",
                                        "Structure juridique",
                                        "- Dénomination\n- Forme juridique\n- Identité du représentant légal de l'entreprise\n- Documents légaux variant en fonction de la structure de votre entreprise et notamment : dénomination, adresse du siège social, le cas échéant le numéro d'identification national, dirigeants (pour les personnes morales), dispositions régissant le pouvoir d'engager la personne morale ou la construction juridique",
                                    ],
                                    [
                                        "",
                                        "Informations relatives aux missions réalisées",
                                        "- Commentaires de vos clients\n- Avis laissés par vos clients",
                                    ],
                                    [
                                        "Générées par l’utilisation de la Marketplace par le worker",
                                        "Données de navigation",
                                        "- Cookies nécessaires et autres cookies sous réserve de votre consentement et adresse IP",
                                    ],
                                ]
                            }
                        },
                        {
                            "h3": "Données relatives aux préposés des clients ou clients",
                            "paragraph": "Nous informons au moment de la collecte du caractère obligatoire ou non de la donnée.",
                            "table": {
                                "th": [
                                    "Type de collecte",
                                    "Catégorie",
                                    "Détails"
                                ],
                                "tr": [
                                    [
                                        "Communiquées par le client / les préposés des clients utilisant la Marketplace",
                                        "Informations personnelles",
                                        "- Nom\n- Prénom\n- Date de naissance\n- Sexe\n- Adresse email\n- Photo de profil",
                                    ],
                                    [
                                        "",
                                        "Informations générales sur l’entreprise",
                                        "- Secteur d'activité\n- Nombre d'employés\n- Logo de l'entreprise",
                                    ],
                                    [
                                        "",
                                        "Structure et informations bancaires",
                                        "- Coordonnées de facturation\n- Contact de comptabilité\n- Relevé d'identité bancaire",
                                    ],
                                    [
                                        "",
                                        "Informations relatives aux missions",
                                        "- Avis reçus par les workers\n- Commentaires laissés par ces workers",
                                    ],
                                    [
                                        "",
                                        "Informations relatives aux échanges avec nos équipes",
                                        "- Emails\n- Dates et durées des appels téléphoniques\n- Contenu des échanges ",
                                    ],
                                    [
                                        "",
                                        "Données de navigation",
                                        "- Cookies nécessaires et autres cookies sous réserve de votre consentement et adresse IP\n(Durée de navigation sur la plateforme )",
                                    ],
                                    [
                                        "Générées par votre utilisation sur la plateforme",
                                        "Informations relatives aux transactions",
                                        "-Détails des transactions",
                                    ],
                                    [
                                        "Données relatives à l’utilisation de la messagerie sécurisée",
                                        "Identification des utilisateurs (expéditeur et destinataire)",
                                        "- Date et heure d’envoi du message\n- Contenu des messages",
                                    ],
                                ]
                            }
                        },
                    ]
                },
            ]
        },
        {
            "h2": "Utilisation des données recueillies",
            "contents": [
                {
                    "type": "paragraph",
                    "inner": "Les données personnelles recueillies sur notre site seront utilisées uniquement aux fins précisées dans la présente politique ou indiquées sur les pages pertinentes de notre site. Nous n'utilisons pas vos données au-delà de ce que nous divulguerons.\nLes données que nous recueillons lorsque l’utilisateur exécute certaines fonctions peuvent être utilisées aux fins suivantes :\nWOS peut utiliser les informations recueillies pour communiquer avec vous au sujet des produits, des services, des promotions, des études, des enquêtes, des actualités, des mises à jour et évènements\nWOS traite la plupart de vos données personnelles dans le cadre du contrat de service que vous avez conclu lors de votre inscription sur le site via l’acceptation de nos CGU"
                },
            ]
        },
        {
            "h2": "Qui a accès aux données recueillies",
            "contents": [
                {
                    "type": "title",
                    "inner": "Employés"
                },
                {
                    "type": "paragraph",
                    "inner": "Nous pouvons divulguer à tout membre de notre organisation les données utilisateur dont il a raisonnablement besoin pour réaliser les objectifs énoncés dans la présente politique."
                },
            ]
        },
        
        {
            "h2": "Politique de cookies du site",
            "contents": [
                {
                    "type": "title",
                    "inner": "Qu'est-ce qu'un cookie ?"
                },
                {
                    "type": "paragraph",
                    "inner": "Un cookie est un petit fichier texte contenant des informations stockées sur votre appareil lorsque vous visitez un site web. Ces fichiers sont utilisés pour améliorer votre expérience en tant qu'utilisateur en mémorisant certaines informations et préférences."
                },
                {
                    "type": "title",
                    "inner": "Quels types de cookies utilisez-vous sur votre site web ?"
                },
                {
                    "type": "paragraph",
                    "inner": "Nous utilisons les types de cookies suivants :\nCookies Essentiels : Ces cookies sont nécessaires au bon fonctionnement du site et vous permettent de naviguer et d'accéder à ses fonctionnalités.\nCookies de suivi et de performance : Ces cookies collectent des informations sur la manière dont les visiteurs utilisent le site, par exemple les pages les plus consultées. Cela nous aide à améliorer la performance de notre site.\nCookies de Fonctionnalité : Ces cookies permettent au site de se souvenir de vos choix et préférences, améliorant ainsi votre expérience utilisateur.\nCookies analytiques \nLes cookies analytiques sont des cookies qui collectent des informations sur la manière dont les visiteurs utilisent un site web. Ils permettent aux propriétaires de sites de comprendre les schémas d'utilisation, les préférences des utilisateurs, et d'obtenir des données statistiques sur la performance du site.\n\nFonctionnement : Ces cookies enregistrent des données telles que le nombre de visiteurs, les pages visitées, le temps passé sur le site, les sources de trafic, etc. Ces informations sont souvent utilisées par les propriétaires de sites pour améliorer la convivialité du site, optimiser le contenu et identifier les zones qui nécessitent des améliorations.\nLes cookies de sécurité\nIls sont conçus pour renforcer la sécurité d'un site web en aidant à détecter et à prévenir les activités malveillantes ou non autorisées.\nFonctionnement : Ces cookies peuvent enregistrer des informations telles que les tentatives de connexion infructueuses, les comportements suspects, ou les activités potentiellement dangereuses. Ils contribuent à protéger le site contre les attaques de sécurité telles que les attaques par force brute ou les tentatives d'accès non autorisé."
                },
                {
                    "type": "title",
                    "inner": "Comment utilisez-vous les cookies ?"
                },
                {
                    "type": "paragraph",
                    "inner": "Nous utilisons les cookies à des fins diverses, notamment pour personnaliser votre expérience sur notre site, analyser le trafic, améliorer nos services, et faciliter les interactions."
                },
                {
                    "type": "title",
                    "inner": "Combien de temps les cookies restent-ils sur l'appareil d'un utilisateur ?"
                },
                {
                    "type": "paragraph",
                    "inner": "La durée de conservation des cookies varie en fonction du type de cookie. Certains cookies restent sur votre appareil pendant la durée de votre session, tandis que d'autres peuvent être conservés plus longtemps."
                },
                {
                    "type": "title",
                    "inner": "Comment les utilisateurs peuvent-ils contrôler leurs paramètres de cookies ?"
                },
                {
                    "type": "paragraph",
                    "inner": "Vous pouvez gérer vos préférences de cookies via les paramètres de votre navigateur. La plupart des navigateurs vous permettent d'accepter, de refuser ou de supprimer les cookies. Cependant, veuillez noter que la désactivation de certains cookies peut affecter la fonctionnalité du site."
                },
                {
                    "type": "title",
                    "inner": "Comment les utilisateurs peuvent-ils vous contacter pour poser des questions sur votre politique de cookies ?"
                },
                {
                    "type": "paragraph",
                    "inner": "Si vous avez des questions ou des préoccupations concernant notre politique de cookies, veuillez nous contacter à l'adresse suivante :\nMerci de visiter Wall of Share. Nous sommes déterminés à garantir une expérience en ligne transparente et sécurisée pour tous nos utilisateurs."
                },
            ]
        },
        {
            "h2": "Comment nous protégeons vos données personnelles",
            "contents": [
                {
                    "type": "list",
                    "inner": [
                        {
                            "paragraph": "Utiliser HTTPS"
                        },
                        {
                            "paragraph": "Mises à jour régulières"
                        },
                        {
                            "paragraph": "Gestion des droits d'accès"
                        },
                        {
                            "paragraph": "Validation des entrées"
                        },
                        {
                            "paragraph": "Protection contre les attaques par force brute"
                        },
                        {
                            "paragraph": "Sécurité des sessions"
                        },
                        {
                            "paragraph": "Protection contre les attaques de déni de service (DDoS"
                        },
                        {
                            "paragraph": "Firewall"
                        },
                        {
                            "paragraph": "Surveillance des journaux"
                        },
                        {
                            "paragraph": "Sécurité des fichiers"
                        },
                        {
                            "paragraph": "Tests de sécurité réguliers"
                        },
                        {
                            "paragraph": "Plan de réponse aux incidents"
                        },
                    ]
                },
                {
                    "type": "paragraph",
                    "inner": "Alors que nous prenons toutes les précautions raisonnables pour nous assurer que nos données d’utilisateur sont sécurisées et que les utilisateurs sont protégés, il reste toujours du risque de préjudice. L’Internet en sa totalité peut être, parfois, peu sûr et donc nous sommes incapables de garantir la sécurité des données des utilisateurs au-delà de ce qui est raisonnablement pratique."
                },
            ]
        },
        {
            "h2": "Mineurs",
            "contents": [
                {
                    "type": "paragraph",
                    "inner": "Le RGPD précise que les personnes de moins de 15 ans sont considérées comme des mineurs aux fins de la collecte de données. Les mineurs doivent avoir le consentement d’un représentant légal pour que leurs données soient recueillies, traitées et utilisées."
                },
            ]
        },
        {
            "h2": "Vos droits en tant qu’utilisateur",
            "contents": [
                {
                    "type": "paragraph",
                    "inner": "En vertu du RGPD, les utilisateurs ont les droits suivants en tant que personnes concernées :\nDroit d’accès\nDroit de rectification\nDroit à l’effacement\nDroit de restreindre le traitement\nDroit à la portabilité des données\nDroit d'objection\nVous trouverez de plus amples informations sur ces droits au chapitre 3 (art 12-23) du RGPD."
                },
            ]
        },
        {
            "h2": "Comment modifier, supprimer ou contester les données recueillies",
            "contents": [
                {
                    "type": "paragraph",
                    "inner": "Si vous souhaitez que vos renseignements soient supprimés ou modifiés d’une façon ou d’une autre, veuillez communiquer avec notre agent de protection de la vie privée ici :\nsarah dahan\ns.dahan@wall-of-share.com\n06 68 52 17 25"
                },
            ]
        },
        {
            "h2": "Contact",
            "contents": [
                {
                    "type": "paragraph",
                    "inner": "Si vous avez des questions à nous poser, n’hésitez pas à communiquer avec nous en utilisant ce qui suit :\ncontact@wall-of-share.com\n198 avenue de Verdun 92130 Issy les Moulineaux"
                },
            ]
        },
        {
            "h2": "",
            "contents": [
                {
                    "type": "paragraph",
                    "inner": "Date d’entrée en vigueur : le 1 avril 2024\n© 2002-2024, Documents Légaux™ (Sequiter Inc.)"
                },
            ]
        },
    ]
};

export default function PDD() {
    return <>
        <Header type="default" />

        <Banner nobg={true} slim={true} data={PDDtext1} />

        <div className="w-[90%] max-w-[1000px] mx-auto py-[100px] flex flex-col gap-[40px]">
            <SEOgenericContent content={PDDtext1} indent={true} lessSpace={true} />
        </div>

        <FooterMaximized />
    </>;
};